/* eslint-disable */
/* tslint:disable */
// @ts-nocheck

import * as configure from "./configure";
import * as forum_common from "./forum_common";

export type Int64 = string | number;

export enum BlackListState {
  Block = 1,
  Unblock = 2,
  Forever = 3,
}

export enum BlockState {
  BLOCK = 1,
  UN_BLOCK = 2,
}

export interface AddAdminRequest {
  UserId: string;
  Email: string;
  ChineseName: string;
  Operator?: string;
}

export interface AddAdminResponse {
  error: number;
  message?: string;
  data?: AddAdminResponseData;
}

export interface AddAdminResponseData {}

export interface AddEmployeeRequest {
  Uid: Int64;
  ChineseName: string;
  Email: string;
  Operator: string;
  Biz?: configure.Biz;
}

export interface AddEmployeeResponse {
  error: number;
  message?: string;
  data?: AddEmployeeResponseData;
}

export interface AddEmployeeResponseData {
  Employee?: Employee;
}

export interface Admin {
  EmailPrefix?: string;
  Email?: string;
  ChineseName?: string;
  Operator?: string;
  CreatedAt?: string;
  UpdatedAt?: string;
}

export interface BlackList {
  UserId?: string;
  State?: BlackListState;
  Duration?: number;
  RestDays?: number;
  ExpiredAt?: string;
  Reason?: string;
  CreatedAt?: string;
  UpdatedAt?: string;
}

export interface BlockInfo {
  Id: string;
  UserId: string;
  ExpiredAt: Int64;
  Reason: string;
  CreatedAt: Int64;
  UpdatedAt: Int64;
}

export interface Comment {
  Id?: string;
  Visible?: boolean;
  Delete?: boolean;
  PostId?: string;
  UserId?: string;
  UserInfo?: User;
  Html?: string;
  Text?: string;
  CreatedAt?: string;
  UpdatedAt?: string;
  PostUrl?: string;
  TcsUrl?: string;
  IsLiked?: boolean;
  Liked?: number;
  Replied?: number;
  Title?: string;
}

export interface Employee {
  Id: string;
  Name: string;
  Email: string;
  ChineseName: string;
  CreatedAt: string;
  UpdatedAt: string;
  Uid: Int64;
  LarkUserId: string;
  LarkOpenId: string;
  Operator: string;
}

export interface GetAdminsRequest {
  Name?: string;
  ChineseName?: string;
  PageNum?: number;
  PageSize?: number;
}

export interface GetAdminsResponse {
  error: number;
  message?: string;
  data?: GetAdminsResponseData;
}

export interface GetAdminsResponseData {
  List: Array<User>;
  PageNum: number;
  PageSize: number;
  TotalNum: number;
}

export interface GetCommentsRequest {
  Uid?: Int64;
  ToUserId?: string;
  PageNum?: number;
  PageSize?: number;
  Biz?: configure.Biz;
}

export interface GetCommentsResponse {
  error: number;
  message?: string;
  data?: GetCommentsResponseData;
}

export interface GetCommentsResponseData {
  PageNum?: number;
  PageSize?: number;
  Total?: number;
  Comments?: Array<Comment>;
}

export interface GetEmployeesRequest {
  Name: string;
}

export interface GetEmployeesResponse {
  error: number;
  message?: string;
  data?: GetEmployeesResponseData;
}

export interface GetEmployeesResponseData {
  Employees?: Array<Employee>;
}

export interface GetPostsRequest {
  Uid?: Int64;
  ToUserId?: string;
  Type?: string;
  PageNum?: number;
  PageSize?: number;
  Biz?: configure.Biz;
}

export interface GetPostsResponse {
  error: number;
  message?: string;
  data?: GetPostsResponseData;
}

export interface GetPostsResponseData {
  PageNum?: number;
  PageSize?: number;
  Total?: number;
  Posts?: Array<Post>;
}

export interface GetRepliesRequest {
  Uid?: Int64;
  ToUserId?: string;
  PageNum?: number;
  PageSize?: number;
  Biz?: configure.Biz;
}

export interface GetRepliesResponse {
  error: number;
  message?: string;
  data?: GetRepliesResponseData;
}

export interface GetRepliesResponseData {
  PageNum?: number;
  PageSize?: number;
  Total?: number;
  Replies?: Array<Reply>;
}

export interface GetUserByIdRequest {
  UserId?: string;
}

export interface GetUserByIdResponse {
  error: number;
  message?: string;
  data?: GetUserByIdResponseData;
}

export interface GetUserByIdResponseData {
  User?: User;
}

export interface GetUserHomeRequest {
  Uid?: Int64;
  ToUserId?: string;
  Biz?: configure.Biz;
}

export interface GetUserHomeResponse {
  error: number;
  message?: string;
  data?: GetUserHomeResponseData;
}

export interface GetUserHomeResponseData {
  User?: User;
  Black?: BlackList;
  Summary?: UserSummary;
  IsFollowed?: boolean;
  UserSummary?: forum_common.UserSummary;
}

export interface GetUserInfoByUidRequest {
  UserId?: string;
  Uid?: Int64;
}

export interface GetUserInfoByUidResponse {
  error: number;
  message?: string;
  data?: GetUserInfoByUidResponseData;
}

export interface GetUserInfoByUidResponseData {
  UserInfo: User;
  BlockInfo?: BlockInfo;
}

export interface GetUserRequest {
  Uid?: Int64;
  Biz?: configure.Biz;
}

export interface GetUserResponse {
  error: number;
  message?: string;
  data?: GetUserResponseData;
}

export interface GetUserResponseData {
  User?: User;
  Black?: BlackList;
}

export interface GetUsersRequest {
  Name?: string;
  PageNum: number;
  PageSize: number;
}

export interface GetUsersResponse {
  error: number;
  message?: string;
  data?: GetUsersResponseData;
}

export interface GetUsersResponseData {
  List: Array<User>;
  PageNum: number;
  PageSize: number;
  TotalNum: number;
}

export interface Post {
  Id?: string;
  Visible?: boolean;
  Delete?: boolean;
  IsTop?: boolean;
  IsGood?: boolean;
  ViewCount?: number;
  CommentCount?: number;
  Scope?: string;
  Type?: string;
  UserId?: string;
  UserInfo?: User;
  Title?: string;
  Html?: string;
  Text?: string;
  Meta?: Record<string, string>;
  CreatedAt?: string;
  UpdatedAt?: string;
  PostUrl?: string;
  TcsUrl?: string;
  FeedbackUrl?: string;
  Liked?: number;
  PostLiked?: number;
  IsLiked?: boolean;
  Collected?: number;
}

export interface RemoveAdminRequest {
  UserId: string;
  Operator?: string;
}

export interface RemoveAdminResponse {
  error: number;
  message?: string;
  data?: RemoveAdminResponseData;
}

export interface RemoveAdminResponseData {}

export interface Reply {
  Id?: string;
  PostId?: string;
  CommentId?: string;
  Visible?: boolean;
  Delete?: boolean;
  UserId?: string;
  UserInfo?: User;
  ToUserId?: string;
  ToUserInfo?: User;
  Html?: string;
  Text?: string;
  CreatedAt?: string;
  UpdatedAt?: string;
  PostUrl?: string;
  TcsUrl?: string;
  IsLiked?: boolean;
  Liked?: number;
  Title?: string;
}

export interface SetUserSummaryRequest {
  Uid?: Int64;
  Biz?: configure.Biz;
}

export interface SetUserSummaryResponse {
  error: number;
  message?: string;
  data?: SetUserSummaryResponseData;
}

export interface SetUserSummaryResponseData {}

export interface ToggleFollowRequest {
  Uid?: Int64;
  ToUserId?: string;
  Biz?: configure.Biz;
}

export interface ToggleFollowResponse {
  error: number;
  message?: string;
  data?: ToggleFollowResponseData;
}

export interface ToggleFollowResponseData {}

export interface UpdateBlockStateByUidRequest {
  UserId?: string;
  Uid?: Int64;
  AdminUserId?: string;
  AdminUid?: Int64;
  BlockState?: BlockState;
  ExpiredAt?: Int64;
  Reason?: string;
  AdminBiz?: configure.Biz;
}

export interface UpdateBlockStateByUidResponse {
  error: number;
  message?: string;
  data?: UpdateBlockStateByUidResponseData;
}

export interface UpdateBlockStateByUidResponseData {}

export interface User {
  Id?: string;
  Name?: string;
  Role?: string;
  Mobile?: string;
  Avatar?: string;
  IfAdmin?: boolean;
  AdminInfo?: Admin;
  CreatedAt?: string;
  WasAdmin?: boolean;
  IsThirdParty?: boolean;
  Biz?: configure.Biz;
}

export interface UserSummary {
  UserId?: string;
  StartTime?: string;
  EndTime?: string;
  UserName?: string;
  InBlacklist?: boolean;
  ReleaseTime?: string;
  Rank?: number;
  Weight?: number;
  Post?: number;
  PostList?: Array<Post>;
  QuestionPost?: number;
  SharePost?: number;
  Viewed?: number;
  AvgViewed?: number;
  ViewedList?: Array<Post>;
  QuestionViewed?: number;
  AvgQuestionViewed?: number;
  ShareViewed?: number;
  AvgShareViewed?: number;
  Comment?: number;
  CommentList?: Array<Comment>;
  Commented?: number;
  Reply?: number;
  ReplyList?: Array<Reply>;
  Replied?: number;
  Like?: number;
  Liked?: number;
  Follow?: number;
  Followed?: number;
  QuestionLiked?: number;
  QuestionLikedList?: Array<Post>;
  ShareLiked?: number;
  ShareLikedList?: Array<Post>;
  CommentLiked?: number;
  CommentLikedList?: Array<Comment>;
  ReplyLiked?: number;
  ReplyLikedList?: Array<Reply>;
  PostReplied?: number;
}
/* eslint-enable */
